import { formatTranslation } from "../../shared/utils/translationUtils";
import { useTranslation } from "react-i18next";
import emptyStateImage from "../../assets/images/Illustration Small Empty.svg";

/**
 * Renders the empty state for the trials table when there is no data available.
 * @param props Props for the component, including loading state, trial data, and empty state image.
 * @returns JSX element for the empty state.
 */
const TableEmptyState = (props: {
  isLoading: boolean;
  trialData: any[];
}): JSX.Element => {
  const { isLoading, trialData } = props;
  const { t } = useTranslation();
  return (
    <>
      {!isLoading && trialData.length === 0 ? (
        <div className="new-empty-state-content">
          <img src={emptyStateImage} alt="No Data" />
          <p className="new-empty-state-title">
            {formatTranslation(t("trials.newEmptyState.title"))}
          </p>
          <p className="new-empty-state-p">
            {formatTranslation(t("trials.newEmptyState.content"))}
          </p>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default TableEmptyState;
